module.exports = __webpack_public_path__ + "static/media/empty_favorites.7c6b2b75.png";